module.exports = __webpack_public_path__ + "static/media/mindful.2b01252b.png";